import React from "react";
import LoginContainer from "../../containers/LoginContainer/LoginContainer";

const LoginPage = () => {
  return <LoginContainer />;
};

export default LoginPage;
